import React from "react";
import { motion } from "framer-motion";
import { waUrl } from "@/lib/site";

const WhatsAppIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" {...props}>
    <path d="M20.52 3.48A11.94 11.94 0 0 0 12.04 0C5.5 0 .2 5.3.2 11.84c0 2.09.55 4.13 1.59 5.93L0 24l6.41-1.68a11.83 11.83 0 0 0 5.63 1.43h.01c6.54 0 11.84-5.3 11.84-11.84 0-3.16-1.23-6.13-3.47-8.37ZM12.05 21.6h-.01a9.74 9.74 0 0 1-4.96-1.36l-.36-.21-3.81 1 1.02-3.71-.23-.38a9.79 9.79 0 1 1 18.16-5.1 9.78 9.78 0 0 1-9.81 9.76Zm5.36-7.28c-.29-.15-1.74-.86-2.01-.96-.27-.1-.47-.15-.66.15-.2.29-.76.96-.94 1.16-.17.2-.34.22-.63.07-.29-.15-1.24-.45-2.36-1.45-.87-.78-1.46-1.74-1.63-2.03-.17-.29-.02-.45.13-.6.13-.13.29-.34.43-.51.15-.17.2-.29.29-.49.1-.2.05-.36-.02-.51-.07-.15-.66-1.58-.9-2.16-.24-.57-.48-.49-.66-.5l-.56-.01a1.07 1.07 0 0 0-.78.36c-.27.29-1.02 1-1.02 2.43 0 1.43 1.05 2.81 1.19 3 .15.2 2.06 3.15 5 4.42.7.3 1.25.48 1.67.62.7.22 1.34.19 1.84.12.56-.08 1.74-.71 1.98-1.39.24-.69.24-1.27.17-1.39-.07-.12-.27-.2-.56-.34Z" />
  </svg>
);

const FloatingWhatsapp = () => {
  return (
    <motion.a
      href={waUrl("Olá! Vim pelo site da Glotaris e gostaria de saber mais.")}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="floating-whatsapp"
      initial={{ opacity: 0, scale: 0.6, y: 30 }}
      animate={{ opacity: 1, scale: 1, y: 0 }}
      transition={{ delay: 1.4, type: "spring", stiffness: 220, damping: 20 }}
      whileHover={{ scale: 1.06, y: -2 }}
      className="fixed bottom-6 right-6 z-50 bg-[#25D366] text-white w-14 h-14 md:w-16 md:h-16 rounded-full flex items-center justify-center shadow-[0_15px_40px_-10px_rgba(37,211,102,0.65)] hover:bg-[#1DA851] transition-colors"
      aria-label="Falar no WhatsApp"
    >
      <span className="absolute inline-flex h-full w-full rounded-full bg-[#25D366] opacity-40 animate-ping" />
      <WhatsAppIcon className="w-7 h-7 md:w-8 md:h-8 relative" />
    </motion.a>
  );
};

export default FloatingWhatsapp;
